import AdminUserTable from "./AdminUserTable";
export default AdminUserTable;
